import { fetchApi } from '@/config/axiosSetting';
import {
  GetPerformanceTrendQueryParamsType,
  GetPerformanceTrendQueryResponseType,
} from './getPerformanceTrendQuery.type';

export const getPerformanceTrendFunction = (
  params: GetPerformanceTrendQueryParamsType,
): Promise<GetPerformanceTrendQueryResponseType> => {
  return fetchApi.get('/survey/performance_trend/', {
    params,
  });
};
